import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";

import {
  RptClientInvoiceSummaryTableDefault,
  columns as rptInterpreter1099Columns,
} from "./RptInterpreter1099jTableDefault";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptInterpreter1099 extends Component {
  static displayName = RptInterpreter1099.name;

  constructor(props) {
    super(props);
    this.state = {
      rptInterpreter1099List: [],
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        StartDate: "",
        EndDate: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));
    this.clickCount = 0;
    this.singleClickTimer = "";

    this.renderRptInterpreter1099Table =
      this.renderRptInterpreter1099Table.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.exportInterpreter1099TXT = this.exportInterpreter1099TXT.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    //
  }

  componentDidMount() {}

  async exportInterpreter1099TXT() {
    exportRowsToExcel({
      rows: this.state.rptInterpreter1099List,
      columns: rptInterpreter1099Columns,
      fileName: "Interpreter1099Report.xlsx",
    });
  }

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRptInterpreter1099();
    }
  }

  async populateRptInterpreter1099() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrptinterpreter1099",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        rptInterpreter1099List: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  renderRptInterpreter1099Table(rptInterpreter1099) {
    return (
      <RptClientInvoiceSummaryTableDefault
        rptInterpreter1099={rptInterpreter1099}
      ></RptClientInvoiceSummaryTableDefault>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptInterpreter1099Table(this.state.rptInterpreter1099List)
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Interpreter 1099 Report</h5>
        <Row className="align-items-center g-2">
          <Col className="col-3">
            <InputGroup size="sm">
              <InputGroupText>Start Date</InputGroupText>
              <input
                name="StartDate"
                ref={(ref) => (this.txtStartDate = ref)}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Date</InputGroupText>
              <input
                name="EndDate"
                ref={(input) => {
                  this.EndDate = input;
                }}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportInterpreter1099TXT}
                title="Export Interpreter 1099 Report"
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <div>{contents}</div>
      </div>
    );
  }
}
